<h1>What do you want to report on?</h1>

<form
  class="flex flex-col items-start gap-4"
  [formGroup]="queryForm"
  (ngSubmit)="submit()"
>
  <mat-form-field class="w-72" subscriptSizing="dynamic">
    <mat-label>Select a data source</mat-label>
    <mat-select formControlName="dataSource" required>
      @for (dataSource of dataSources; track dataSource.id) {
        <mat-option
          matTooltipPosition="right"
          matTooltipShowDelay="300"
          [matTooltip]="dataSource.description"
          [value]="dataSource"
          >{{ dataSource.name }}</mat-option
        >
      }
    </mat-select>
  </mat-form-field>

  @if (queryForm.value.dataSource; as dataSource) {
    <div class="flex flex-row flex-wrap gap-4">
      @if (dataSource | map: dataSourceHasBrandPracticeScopes : this | async) {
        <pr-query-scope-form
          [dataSource]="dataSource"
          [scopeForms]="queryScopeForms"
          (formChange)="queryForm.patchValue({ scopeRequests: $event })"
        />
      }
      <pr-report-builder-date-range-form
        [dataSource]="dataSource"
        (dateRangeChange)="dateRangeForm.patchValue($event)"
      />
    </div>
  }

  <button mat-flat-button color="primary" [disabled]="submitDisabled$ | async">
    <mat-icon>play_arrow</mat-icon> Start Exploring
  </button>
</form>
